import './Profile.css'
import {MostPopular,Hero,GamingLibrary} from '../../sections/index'

const Home = () => {
  return (
    <>
    <h1></h1>
      <MostPopular/>
      </>
  )
  
}

export default Home